import React, { useEffect, useState, memo } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Email from "@material-ui/icons/MailOutline";
import Exit from "@material-ui/icons/ExitToApp";
import M_UserAvatar from "./M_UserAvatar";
import A_Divider from "../../../Atoms/DataDisplay/Dividers/A_Divider";
import {
  excludedClientsForProfileSetting,
  isClientAuthorised,
} from "./M_NavBarhelper";
import {
  getCurrentUser,
  getCRMContactInfo,
} from "../../../../../Utils/Helpers/common";
import {
  getAllUsers,
  getUserImages,
} from "../../../../Utils/Oidc/apiService";
import { setAllUsers } from "../../../../../store/actions/userActions";
import SyncIcon from "@material-ui/icons/Sync";
import { CircularProgress } from "@material-ui/core";
import { useDispatch } from "react-redux";
import useStyles from "./M_UserArea.styles";

const M_ProfileMenu = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const [currentuser, setCurrentuser] = useState("");
  const { displayName, userDesignation } = getCurrentUser();
  const loggedInUserDetail = JSON.parse(localStorage.getItem("contact_crm"));
  const { crmContactUserId } = getCRMContactInfo();
  const dispatch = useDispatch();
  const [syncLoading, setSyncLoading] = useState(false);
  const userid = useSelector((state) =>
    state?.getLoggedInUserReducer?.data?.[0]?.id || 
    loggedInUserDetail?.id || 
    crmContactUserId
  );

  useEffect(() => {
    setCurrentuser(userid ? userid : "");
  }, [userid]);

  const { t: translate } = props;
  const handleMenuClick = (clickedMenu) => {
    props.handleClose(clickedMenu);
  };
  const [showProfileSetting] = useState(
    isClientAuthorised(
      window.location.hostname,
      excludedClientsForProfileSetting
    )
  );

  function mailBox() {
    window.location = `mailto:help@htb.co.uk`;
  }

  const handleClickToRedirect = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (currentuser !== "") {
      history.push(
        `/contact/${currentuser}/1ceb4a1e-462a-4f62-a6ef-5736e415e8a9`
      );
      props.handleClose();
    }
  };

  const handleSync = async () => {
    try {
      setSyncLoading(true);
      const usersRes = await getAllUsers();
      if (usersRes && usersRes.Contacts) {
        const users = usersRes.Contacts;
        const emails = users
          .map((u) => u.Email || u.email || u.EmailAddress)
          .filter((e) => e);

        if (emails.length > 0) {
          const profileImageKeys = emails.map((email) => `profile_${email}`);
          const imagesRes = await getUserImages(profileImageKeys);
          const images = imagesRes && imagesRes.image ? imagesRes.image : [];

          const combinedUsers = users.map((user) => {
            const email = user.Email || user.email || user.EmailAddress;
            const userImage = images.find(
              (img) => img.file === `profile_${email}`
            );
            return {
              ...user,
              email: email, // ensure consistent email key
              image: userImage ? userImage.link : null,
            };
          });
          dispatch(setAllUsers(combinedUsers));
        } else {
          dispatch(setAllUsers(users));
        }
      }
    } catch (error) {
      console.error("Error fetching users or images:", error);
    } finally {
      setSyncLoading(false);
    }
  };
  return (
    <React.Fragment>
      <List component="nav" aria-label="user area" className={classes.profileMenuList}>
        <ListItem
          className={classes.profileHeaderItem}
          onClick={() => {
            props.handleClose();
          }}
        >
          <ListItemIcon>
            <div className={classes.avatarContainer}>
              <M_UserAvatar logoImage={props.logoImage} />
              <div
                className={classes.syncIconBadge}
                onClick={(e) => {
                  e.stopPropagation();
                  handleSync();
                }}
                style={{ cursor: "pointer" }}
              >
                {syncLoading ? (
                  <CircularProgress size={12} color="inherit" />
                ) : (
                  <SyncIcon />
                )}
              </div>
            </div>
          </ListItemIcon>
          <ListItem
            component={currentuser ? "a" : "div"}
            className={classes.profileHeaderLink}
            style={{
              cursor: currentuser ? "pointer" : "not-allowed",
            }}
            onClick={handleClickToRedirect}
            disabled={currentuser ? false : true}
          >
            <ListItemText
              primary={displayName}
              secondary={userDesignation}
              primaryTypographyProps={{
                className: `${classes.profileName} ${
                  currentuser ? classes.profileNameAsLink : ""
                }`,
              }}
              secondaryTypographyProps={{
                className: classes.profileDesignation,
              }}
            />
          </ListItem>
        </ListItem>
        <div className={showProfileSetting ? "" : classes.hideProfileSetting}>
          <A_Divider />
        </div>
        <ListItem
          button
          className={classes.profileMenuItem}
          onClick={() => {
            mailBox("Contact Support");
          }}
        >
          <Email className={classes.profileMenuItemIcon} />
          <ListItemText
            primary={translate ? translate("Contact Support") : "Contact Support"}
            primaryTypographyProps={{ className: classes.profileMenuItemText }}
          />
        </ListItem>
        <A_Divider />
        <ListItem
          button
          className={`${classes.profileMenuItem} ${classes.profileLogoutItem}`}
          onClick={() => handleMenuClick("logout")}
        >
          <Exit className={classes.profileMenuItemIcon} />
          <ListItemText
            primary={translate ? translate("Logout") : "Logout"}
            primaryTypographyProps={{ className: classes.profileMenuItemText }}
          />
        </ListItem>
      </List>
    </React.Fragment>
  );
};

M_ProfileMenu.propTypes = {
  t: PropTypes.any,
  handleClose: PropTypes.func,
  logoImage: PropTypes.string,
};

export default memo(M_ProfileMenu);
